/**
 * The announcement contract for a typed field that refuses something.
 *
 * `role="alert"` is assertive by definition, so an explicit `aria-live="polite"` next to it
 * does not reinforce it, it overrides it: the rejection would queue behind whatever the screen
 * reader was already saying. These errors are refusals of the action the user just took (a file
 * the field will not accept), so they interrupt.
 *
 * Only a field that can actually refuse renders one, which today is the file field alone. A url
 * is stored whatever its scheme, a date that will not parse renders as unset, and a checklist can
 * only emit the options it drew, so an alert element in those announces nothing while reading
 * like a promise that it does. A field that grows a refusal takes these props and fills the slot;
 * an empty one is not the same thing as a quiet one.
 */
/* eslint-disable i18next/no-literal-string -- ARIA role token and test hook, not copy */
export const ERROR_SLOT_PROPS = {
  'data-testid': 'brief-section-field-error-slot',
  role: 'alert',
} as const;
/* eslint-enable i18next/no-literal-string */
